var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { AdminLayout } from 'src/Layouts';
import React, { useEffect, useRef } from 'react';
import TicketReminderForm from 'src/Components/TicketReminderForm/TicketReminderForm';
import { ticketsService } from 'src/Utils/ticketsService';
import { useHistory } from 'react-router-dom';
import { ROUTES } from 'src/Utils';
import { useSearchParams } from 'src/Utils/hooks/useSearchParams';
import { getSearchParams } from 'src/Utils/getQueryParams';
import AdminSection from 'src/Components/AdminSection/AdminSection';
import { ERROR_MESSAGES, SUCCESS_MESSAGES, getCompletedTicketReminderWarningMessage, } from 'src/Utils/toastMessages';
import { showErrorToast, showSuccessToast, showWarningToast, } from 'src/Utils/toastHelper';
import { useMutation } from 'react-query';
import { usePrefilledTicketId } from './hooks/usePrefilledTicketId';
import { useQueryCache } from 'react-query';
import { TICKET_REMINDERS_API } from 'src/Utils';
function CreateTicketReminder() {
    var _this = this;
    var searchParams = useSearchParams();
    var history = useHistory();
    var ticketIdFromQuery = searchParams.get('ticket_id');
    var ticketNumberFromQuery = searchParams.get('ticket_number');
    var _a = usePrefilledTicketId({
        ticketIdParam: ticketIdFromQuery,
        ticketNumberParam: ticketNumberFromQuery,
    }), initialTicketId = _a.initialTicketId, completedFilteredTicketNumber = _a.completedFilteredTicketNumber;
    var lastWarnedTicketRef = useRef(undefined);
    var queryCache = useQueryCache();
    var _b = useMutation(function (ticketReminderData) { return __awaiter(_this, void 0, void 0, function () {
        var date;
        return __generator(this, function (_a) {
            date = ticketReminderData.date;
            return [2 /*return*/, ticketsService.createTicketReminder(__assign(__assign({}, ticketReminderData), { date: date.toISOString() }))];
        });
    }); }, {
        onSuccess: function (reminder) {
            showSuccessToast(SUCCESS_MESSAGES.ticketReminders.created);
            queryCache.invalidateQueries([TICKET_REMINDERS_API]);
            history.push(ROUTES.recordatorios_de_tickets + "?" + getSearchParams({
                ticket_number: reminder.ticket_number,
            }));
        },
        onError: function (error) {
            showErrorToast(error, ERROR_MESSAGES.ticketReminders.create);
        },
    }), createTicketReminder = _b[0], isCreatingTicketReminder = _b[1].isLoading;
    var handleSubmit = function (ticketReminderData) {
        createTicketReminder(ticketReminderData);
    };
    useEffect(function () {
        if (completedFilteredTicketNumber === undefined ||
            lastWarnedTicketRef.current === completedFilteredTicketNumber) {
            return;
        }
        showWarningToast(getCompletedTicketReminderWarningMessage(completedFilteredTicketNumber));
        lastWarnedTicketRef.current = completedFilteredTicketNumber;
    }, [completedFilteredTicketNumber]);
    return (React.createElement(AdminLayout, null,
        React.createElement(AdminSection, { title: "Crear recordatorio de ticket" },
            React.createElement(TicketReminderForm, { key: "ticket-reminder-form-" + (initialTicketId !== null && initialTicketId !== void 0 ? initialTicketId : 'none') + "-" + (ticketNumberFromQuery !== null && ticketNumberFromQuery !== void 0 ? ticketNumberFromQuery : 'none'), submitLoading: isCreatingTicketReminder, ticketId: initialTicketId, onSubmit: handleSubmit }))));
}
export default CreateTicketReminder;
